/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style8 = require("antd/lib/table/style");

var _table = require("antd/lib/table");

var _table2 = _interopRequireDefault(_table);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _style9 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _getOwnPropertyNames = require("babel-runtime/core-js/object/get-own-property-names");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _style10 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _style11 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style12 = require("antd/lib/select/style");

var _select = require("antd/lib/select");

var _select2 = _interopRequireDefault(_select);

var _style13 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _style14 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _actions = require("../../../redux/actions");

var Actions = _interopRequireWildcard(_actions);

var _tool = require("../../../utils/tool");

var _template = require("../../../common/template");

var _template2 = _interopRequireDefault(_template);

var _interValidate = require("util/interValidate");

require("./index.less");

var _config = require("util/config");

var _reactFreeScrollbar = require("react-free-scrollbar");

var _reactFreeScrollbar2 = _interopRequireDefault(_reactFreeScrollbar);

var _url = require("url");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var TextArea = _input2.default.TextArea;

var Option = _select2.default.Option;

var _ref = (0, _jsx3.default)("p", {}, void 0, "\u65B0\u589E\u8F66\u8F86\u6210\u529F\uFF01");

var _ref2 = (0, _jsx3.default)("p", {}, void 0, "\u65B0\u589E\u8F66\u8F86\u6210\u529F\uFF01");

var _ref3 = (0, _jsx3.default)("a", {
  href: "javascript:;"
}, void 0, "\u5220\u9664");

var _ref4 = (0, _jsx3.default)(_button2.default, {
  type: "primary",
  htmlType: "submit"
}, void 0, "\u786E\u5B9A");

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.state = {
      serialNumberStr: '',
      serialNumberObj: [],
      reomveSerialNumberObj: [],
      selectedRowKeys: [],
      salesArea: '',
      checkVIN: '',
      areaOptions: [],
      registerNumber: '',
      productTemplate: null,
      visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: "getProductTemplate",
    value: function getProductTemplate() {
      var _this2 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this2.setState({
          productTemplate: res.productTemplate
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.queryDeviceSalesAreas();
      this.getProductDetail();
    }
  }, {
    key: "queryDeviceSalesAreas",
    value: function queryDeviceSalesAreas() {
      var _this3 = this;

      (0, _tool.http)(_config.apiJson.queryDeviceSalesAreas, {
        productId: this.props.params.id
      }).then(function (res) {
        _this3.setState({
          areaOptions: res,
          salesArea: res[0].channelCode
        });
      });
    }
  }, {
    key: "getProductDetail",
    value: function getProductDetail() {
      var _this4 = this;

      var _props = this.props,
          params = _props.params,
          product = _props.product;

      (0, _tool.http)(_config.apiJson.getProduct, { productId: params.id }).then(function (res) {
        _this4.setState({
          registerNumber: res.registerNumber,
          productTemplate: res.productTemplate
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this5 = this;

      e.preventDefault();
      this.props.form.validateFields(function (err, values) {
        if (!err) {
          if (_this5.state.checkVIN == false) {
            _message2.default.warning('请点击“检测”进行VIN校验');
            return;
          }
          var registerNumber = _this5.state.registerNumber;
          var params = _this5.props.params;

          var VINCodeList = values.serialNumbers.split(/[\n]/);
          var options = {
            VINCodeList: VINCodeList,
            salesArea: values.salesArea,
            registerNumber: registerNumber
          };
          (0, _tool.http)(_config.apiJson.registerBatchDevice, options).then(function (res) {
            var successArr = [];
            var warningArr = [];
            res.forEach(function (item) {
              if (item.success) {
                successArr.push(item);
              } else {
                warningArr.push(item);
              }
            });
            _modal2.default.info({
              title: '提示',
              content: (0, _jsx3.default)("div", {}, void 0, successArr.length > 0 ? (0, _jsx3.default)("div", {}, void 0, successArr.map(function (item) {
                return (0, _jsx3.default)("p", {}, void 0, item.deviceId);
              }), _ref) : '', warningArr.map(function (item) {
                return (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)("p", {}, void 0, item.deviceId), (0, _jsx3.default)("p", {}, void 0, "\u8F66\u8F86\u6DFB\u52A0\u5931\u8D25\uFF1A", item.message));
              })),
              onOk: function onOk() {
                _this5.props.router.push({ pathname: "/device/index/" + params.id });
              }
            });
            // if(res.length) {
            //     Message.success('新增车辆成功，正在跳转')
            //     this.props.router.push(
            //         {pathname: `/device/index/${params.id}`}
            //     )
            // } else {
            //     Message.warning('新增车辆失败，请重试')
            // }
          });
        }
      });
    }
  }, {
    key: "handelChange",
    value: function handelChange() {
      this.setState({
        checkVIN: false
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this6 = this;

      e.preventDefault();
      this.props.form.validateFields(function (err, values) {
        if (!err) {
          if (_this6.state.checkVIN == false) {
            _message2.default.warning("请点击“检测”进行VIN校验");
            return;
          }
          var registerNumber = _this6.state.registerNumber;
          var params = _this6.props.params;

          var VINCodeList = values.serialNumbers.split(/[\n]/);

          var options = {
            VINCodeList: VINCodeList,
            registerNumber: registerNumber,
            channelCode: values.salesArea
          };
          (0, _tool.http)(_config.apiJson.registerBatchDevice, options).then(function (res) {
            var successArr = [];
            var warningArr = [];
            res.forEach(function (item) {
              if (item.success) {
                successArr.push(item);
              } else {
                warningArr.push(item);
              }
            });
            _modal2.default.info({
              title: '提示',
              content: (0, _jsx3.default)("div", {}, void 0, successArr.length > 0 ? (0, _jsx3.default)("div", {}, void 0, successArr.map(function (item) {
                return (0, _jsx3.default)("p", {}, void 0, item.deviceId);
              }), _ref2) : '', warningArr.map(function (item) {
                return (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)("p", {}, void 0, item.deviceId), (0, _jsx3.default)("p", {}, void 0, "\u8F66\u8F86\u6DFB\u52A0\u5931\u8D25\uFF1A", item.message));
              })),
              onOk: function onOk() {
                _this6.props.router.push({ pathname: "/device/index/" + params.id });
              }
            });
            // if (res.length) {
            //   Message.success("新增车辆成功，正在跳转");
            //   this.props.router.push({ pathname: `/device/index/${params.id}` });
            // } else {
            //   Message.warning("新增车辆失败，请重试");
            // }
          });
        }
      });
    }
  }, {
    key: "handelChange",
    value: function handelChange() {
      this.setState({
        checkVIN: false
      });
    }
  }, {
    key: "checkingVinCode",
    value: function checkingVinCode(deviceIdList) {
      return new _promise2.default(function (resolve, reject) {
        (0, _tool.http)(_config.apiJson.checkingVinCode, "deviceIdList=" + deviceIdList, "POST", true).then(function (res) {
          resolve(res);
        });
      });
    }
  }, {
    key: "handelError",
    value: function handelError(title, content) {
      var opt = content.map(function (d) {
        return (0, _jsx3.default)("p", {}, d.key, "\u5E8F\u53F7", d.key, ": \u6DFB\u52A0\u6709\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u683C\u5F0F");
      });
      _modal2.default.error({
        title: title,
        content: (0, _jsx3.default)("div", {}, void 0, opt)
      });
    }
  }, {
    key: "checkSerial",
    value: function checkSerial() {
      var _this7 = this;

      var serialNumberStr = this.props.form.getFieldValue("serialNumbers");
      console.log(serialNumberStr, '我是校验值');

      if (serialNumberStr) {
        var serialNumberList = serialNumberStr.split(/[\n]/);
        var serialNumberObj = [];
        var errorSerialNumberObj = [];
        var tmpStr = "";
        serialNumberList.length > 0 ? serialNumberList.map(function (item, key) {
          var tmp = {
            key: key + 1,
            serialNumber: item
          };
          // 正则眼正VIN
          // && vinValidate(item)
          if (item && (0, _interValidate.vinValidate)(item)) {
            serialNumberObj.push(tmp);
            if (key + 1 == serialNumberList.length) {
              tmpStr += item;
            } else {
              tmpStr += item + "\n";
            }
          } else {
            errorSerialNumberObj.push(tmp);
          }
        }) : null;
        if (errorSerialNumberObj.length > 0) {
          this.handelError("格式错误", errorSerialNumberObj);
          return;
        }

        this.checkingVinCode(serialNumberList).then(function (res) {
          if (res.length > 0) {
            _modal2.default.error({
              title: '以下VIN码已注册过，请删除后重新提交',
              content: (0, _jsx3.default)("div", {}, void 0, res.join(','))
            });
            return;
          }
          var temp = [];
          for (var i = 0; i < serialNumberObj.length; i++) {
            if (temp.indexOf(serialNumberObj[i].serialNumber) == -1) {
              temp.push(serialNumberObj[i]);
            } else {
              _message2.default.error('请不要填写重复的VIN码');
              return false;
            }
          }
          _this7.setState({
            serialNumberObj: serialNumberObj,
            serialNumberStr: tmpStr,
            checkVIN: true
          }, function () {
            _this7.props.form.setFieldsValue({
              serialNumbers: _this7.state.serialNumberStr
            });
            document.getElementById("text").value = _this7.state.serialNumberStr;
          });
        });
      } else {
        _message2.default.warning("请输入车辆编码，一行一个");
      }
    }
  }, {
    key: "cancleClick",
    value: function cancleClick() {
      var id = this.props.params.id;

      this.props.router.push({ pathname: "/device/index/" + id });
    }
  }, {
    key: "removeSerialObj",
    value: function removeSerialObj(record) {
      var _this8 = this;

      Array.prototype.indexOf = function (val) {
        function isEqual(a, b) {
          //如果a和b本来就全等
          if (a === b) {
            //判断是否为0和-0
            return a !== 0 || 1 / a === 1 / b;
          }
          //判断是否为null和undefined
          if (a == null || b == null) {
            return a === b;
          }
          //接下来判断a和b的数据类型
          var classNameA = toString.call(a),
              classNameB = toString.call(b);
          //如果数据类型不相等，则返回false
          if (classNameA !== classNameB) {
            return false;
          }
          //如果数据类型相等，再根据不同数据类型分别判断
          switch (classNameA) {
            case "[object RegExp]":
            case "[object String]":
              //进行字符串转换比较
              return "" + a === "" + b;
            case "[object Number]":
              //进行数字转换比较,判断是否为NaN
              if (+a !== +a) {
                return +b !== +b;
              }
              //判断是否为0或-0
              return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case "[object Date]":
            case "[object Boolean]":
              return +a === +b;
          }
          //如果是对象类型
          if (classNameA == "[object Object]") {
            //获取a和b的属性长度
            var propsA = (0, _getOwnPropertyNames2.default)(a),
                propsB = (0, _getOwnPropertyNames2.default)(b);
            if (propsA.length != propsB.length) {
              return false;
            }
            for (var i = 0; i < propsA.length; i++) {
              var propName = propsA[i];
              //如果对应属性对应值不相等，则返回false
              if (a[propName] !== b[propName]) {
                return false;
              }
            }
            return true;
          }
          //如果是数组类型
          if (classNameA == "[object Array]") {
            if (a.toString() == b.toString()) {
              return true;
            }
            return false;
          }
        }
        for (var i = 0; i < this.length; i++) {
          if (isEqual(this[i], val)) return i;
        }
        return -1;
      };
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      var serialNumberObj = this.state.serialNumberObj;

      serialNumberObj.remove(record);
      var serialNumberStr = "";
      serialNumberObj.map(function (item, key) {
        serialNumberStr += item.serialNumber + "\n";
      });
      this.setState({
        serialNumberObj: serialNumberObj,
        serialNumberStr: serialNumberStr
      }, function () {
        _this8.props.form.setFieldsValue({
          serialNumbers: _this8.state.serialNumberStr
        });
        document.getElementById("text").value = _this8.state.serialNumberStr;
      });
    }
  }, {
    key: "removeSerialObjs",
    value: function removeSerialObjs() {
      var _this9 = this;

      var reomveSerialNumberObj = this.state.reomveSerialNumberObj;

      if (reomveSerialNumberObj.length > 0) {
        reomveSerialNumberObj.map(function (item, key) {
          _this9.removeSerialObj(item);
        });
      } else {
        _message2.default.warning("请选择要删除的号码！");
      }
      this.setState({
        selectedRowKeys: []
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var _props2 = this.props,
          form = _props2.form,
          params = _props2.params,
          product = _props2.product;
      var _state = this.state,
          serialNumberStr = _state.serialNumberStr,
          serialNumberObj = _state.serialNumberObj,
          selectedRowKeys = _state.selectedRowKeys,
          salesArea = _state.salesArea,
          areaOptions = _state.areaOptions,
          productTemplate = _state.productTemplate;
      var getFieldDecorator = form.getFieldDecorator;

      var formItemCol = {
        labelCol: { span: 7 },
        wrapperCol: { span: 16, offset: 1 }
      };
      var columns = [{
        title: '序号',
        dataIndex: 'key'
      }, {
        title: '号码',
        dataIndex: 'serialNumber'
      }, {
        title: '操作',
        dataIndex: 'operation',
        render: function render(text, record) {
          return (0, _jsx3.default)("div", {
            onClick: function onClick() {
              return _this10.removeSerialObj(record);
            }
          }, void 0, _ref3);
        }
      }];

      var rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: function onChange(selectedRowKeys, selectedRows) {
          _this10.setState({
            selectedRowKeys: selectedRowKeys,
            reomveSerialNumberObj: selectedRows
          });
        },
        getCheckboxProps: function getCheckboxProps(record) {
          return {
            id: record.id
          };
        }
      };

      var salesAreaOptions = areaOptions.map(function (d) {
        return (0, _jsx3.default)(Option, {}, d.channelCode, d.channelName);
      });

      return (0, _jsx3.default)("div", {
        className: "device-insert"
      }, void 0, (0, _jsx3.default)("div", {
        className: "forms"
      }, void 0, (0, _jsx3.default)(_form2.default, {
        style: { float: 'left' },
        onSubmit: this.handleSubmit.bind(this)
      }, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({
          label: '添加VIN码'
        }, formItemCol),
        (0, _jsx3.default)("div", {
          className: "cover-text"
        }, void 0, getFieldDecorator('serialNumbers', {
          rules: [{ required: true, message: "请输入车辆编码，一行一个" }],
          initialValue: "" + serialNumberStr
        })((0, _jsx3.default)("div", {
          className: "serial"
        }, void 0, (0, _jsx3.default)(TextArea, {
          id: "text",
          style: { height: '395px' },
          placeholder: "请输入车辆编码，一行一个",
          onChange: this.handelChange.bind(this)
        }), (0, _jsx3.default)("div", {
          className: "btnlist"
        }, void 0, (0, _jsx3.default)(_button2.default, {
          onClick: this.checkSerial.bind(this)
        }, void 0, "\u68C0\u6D4B")))))
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemCol, { label: "\u6E20\u9053" }),
        getFieldDecorator("salesArea", {
          rules: [{ required: true, message: "请选择渠道" }],
          initialValue: "" + salesArea
        })((0, _jsx3.default)(_select2.default, {
          placeholder: "\u8BF7\u9009\u62E9\u6E20\u9053"
        }, void 0, salesAreaOptions))
      ), (0, _jsx3.default)(FormItem, {
        wrapperCol: { span: 24 }
      }, void 0, (0, _jsx3.default)("div", {
        className: "btn-group"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: "default",
        onClick: this.cancleClick.bind(this)
      }, void 0, "\u53D6\u6D88"), _ref4))), serialNumberObj.length > 0 ? (0, _jsx3.default)("div", {
        style: { float: "left" },
        className: "device-list"
      }, void 0, (0, _jsx3.default)(_reactFreeScrollbar2.default, {
        style: { width: "100%", height: "100%" }
      }, void 0, (0, _jsx3.default)(_table2.default, {
        rowSelection: rowSelection,
        columns: columns,
        dataSource: serialNumberObj,
        pagination: false
      })), (0, _jsx3.default)("div", {
        className: "bun"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        onClick: function onClick() {
          return _this10.removeSerialObjs();
        }
      }, void 0, "\u6279\u91CF\u5220\u9664"))) : null));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _template2.default)({
  id: "", //应用关联使用的redux
  component: _form2.default.create()(Main), //接收数据的组件入口
  url: ""
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/insert/index.jsx
// module id = 966
// module chunks = 0